import { render, staticRenderFns } from "./TermsDefaultEs.vue?vue&type=template&id=e3dbab54&scoped=true&"
import script from "./TermsDefaultEs.vue?vue&type=script&lang=js&"
export * from "./TermsDefaultEs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3dbab54",
  null
  
)

export default component.exports